import _ from 'lodash';
import * as XLSX from 'xlsx';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';

import DecimalAmount from '../../../../../support/DecimalAmount';
import Loading from '../../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../../shared/responses/ResponseResult';

class ConceptosUploadFile extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      progress: 0,
      validator: new Validator({}, this.rules),
      show: props.show,
    };
  }

  get rules() {
    return {
      'data.*.NoIdentificacion': [],
      'data.*.Cantidad': ['required', 'numeric'],
      'data.*.ValorUnitario': ['required', 'numeric'],
      'data.*.Descuento': ['numeric'],
      'data.*.Descripcion': ['required'],
      'data.*.ObjetoImp': ['required', 'string'],
      'data.*.ClaveUnidad': ['string'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnReaderFile = (event) => {
    this.setState({
      progress: 1,
    });

    const file = event.target.files[0];
    const fileReader = new FileReader();

    try {
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const xlsx = XLSX.read(bufferArray, { type: 'buffer' });
        const name = xlsx.SheetNames[0];
        const sheet = xlsx.Sheets[name];
        const data = XLSX.utils.sheet_to_json(sheet);

        const validator = this.validate({ data });
        const isValid = validator.passes();

        if (!!isValid) {
          this.setState({ data: data });

          this.handleOnAdd(data);
        } else {
          let errors = _.map(validator.errors.all(), (error, key) => {
            const fila = key.split('.');

            return _.map(error, (value) => {
              let message = value.replace(`${fila[0]}.${fila[1]}.`, '');
              message = `Fila ${parseInt(fila[1]) + 2}: ` + message;

              return { message: message };
            });
          });

          errors = errors.flat();

          const error = {
            message: 'Error de validación',
            errors: [...errors],
          };

          this.setState({
            showError: true,
            error: error,
          });
        }
      };

      event.target.value = null;
    } catch (error) {
      //
    }
  };

  handleOnAdd = (data) => {
    const newData = _.map(data, (item) => {
      item = _.assign(item, {
        ClaveProdServ: !!item.ClaveProdServ ? item.ClaveProdServ.toString() : '01010101',
        NoIdentificacion: !!item.NoIdentificacion ? item.NoIdentificacion.toString() : '',
        Cantidad: !!item.Cantidad ? item.Cantidad.toString() : '',
        ClaveUnidad: !!item.ClaveUnidad ? item.ClaveUnidad.toString() : 'XNA',
        Unidad: !!item.Unidad ? item.Unidad.toString() : 'No disponible',
        Descripcion: !!item.Descripcion ? item.Descripcion.toString() : '',
        ValorUnitario: !!item.ValorUnitario ? DecimalAmount.make(item.ValorUnitario.toString()).toFixed(6) : '',
        Importe: !!item.Importe ? DecimalAmount.make(item.Importe.toString()).toFixed(6) : '',

        Descuento: !!item.Descuento ? DecimalAmount.make(item.Descuento.toString()).toFixed(6) : '0.00',
        ObjetoImp: !!item.ObjetoImp ? item.ObjetoImp.toString() : '',
        Impuestos: {
          Traslados: {
            Traslado: [
              {
                Base: !!item.TrasladoBase ? DecimalAmount.make(item.TrasladoBase.toString()).toFixed(6) : undefined,
                Impuesto: !!item.TrasladoImpuesto ? item.TrasladoImpuesto.toString() : undefined,
                TipoFactor: !!item.TrasladoTipoFactor ? item.TrasladoTipoFactor.toString() : undefined,
                TasaOCuota: !!item.TrasladoTasaOCuota ? item.TrasladoTasaOCuota.toString() : undefined,
                Importe: !!item.TrasladoImporte
                  ? DecimalAmount.make(item.TrasladoImporte.toString()).toFixed(6)
                  : undefined,
              },
            ],
          },
          Retenciones: {
            Retencion: [
              {
                Base: !!item.RetencionBase ? DecimalAmount.make(item.RetencionBase.toString()).toFixed(6) : undefined,
                Impuesto: !!item.RetencionImpuesto ? item.RetencionImpuesto.toString() : undefined,
                TipoFactor: !!item.RetencionTipoFactor ? item.RetencionTipoFactor.toString() : undefined,
                TasaOCuota: !!item.RetencionTasaOCuota ? item.RetencionTasaOCuota.toString() : undefined,

                Importe: !!item.RetencionImporte
                  ? DecimalAmount.make(item.RetencionImporte.toString()).toFixed(6)
                  : undefined,
              },
            ],
          },
        },
      });

      if (item.Impuestos.Traslados.Traslado[0].Base === undefined) {
        item.Impuestos.Traslados = undefined;
      }

      if (item.Impuestos.Retenciones.Retencion[0].Base === undefined) {
        item.Impuestos.Retenciones = undefined;
      }

      if (item.ObjetoImp === '01' || item.ObjetoImp === '03') {
        item.Impuestos = undefined;
      }

      return item;
    });

    this.props.onAdd(newData);

    const result = {
      message: `Se agregaron un total de ${newData.length} conceptos, se mostrarán en la tabla de conceptos.`,
    };

    this.setState({
      progress: 100,
      result: result,
      showResult: true,
    });
  };

  handleOnAction = () => {
    this.setState({
      showResult: false,
      showError: false,
    });

    this.handleOnClose();

    return;
  };

  handleOnClose = () => {
    const data = {
      show: false,
    };

    this.props.onClose(data);
  };

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data, progress, showResult, showError, show } = this.state;

    if (progress === 100 && !!showResult) {
      return this.renderResult();
    }

    if (!!showError) {
      return this.renderError();
    }

    return (
      <Modal
        backdrop="static"
        keyboard={false}
        show={show}
        centered={true}
        onHide={this.handleOnClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <label>
                <input
                  type="file"
                  accept=".csv, .xls, .xlsx"
                  onChange={this.handleOnReaderFile}
                />
              </label>

              {progress > 0 && progress < 100 && !!data && (
                <Row>
                  <Col>
                    <Loading className="mt-3 ml-3" />
                  </Col>
                </Row>
              )}

              <div className="p-3">
                <label>Instrucciones.</label>
                <ul className="list-unstyled">
                  <li>
                    1.{' '}
                    <a
                      target="_blank"
                      href="/resources/template-conceptos.xlsx"
                    >
                      Descarga
                    </a>{' '}
                    el template
                  </li>
                  <li>2. Sigue la guía de llenado</li>
                  <li>3. Sube el archivo</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ConceptosUploadFile;
